import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'shared/withRouter';
import { Templates, SavedTemplates } from './TemplateGallery';

import './Campaign.scss';
import constant from 'shared/utils/constant';

class Popup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTab: ''
        }
    }
    componentDidMount() {
        this.updateActivePage();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.router.location.pathname !== this.props.router.location.pathname) {
            this.updateActivePage();
        }
    }

    updateActivePage = () => {
        const currentTab = this.props.router.params.tab;
        this.setState({
            currentTab
        });
    }

    render() {
        return (
            <div className='campaign-container h-100'>
                {
                    this.state.currentTab ?
                        this.state.currentTab === 'templates' ?
                            <Templates link={'POP_UP'} pageIs={constant.POPUP} /> :
                            <SavedTemplates link={'POP_UP'} pageIs={constant.POPUP} />
                        : null
                }
            </div>
        );
    }
}

export default connect(state => state)(withRouter(Popup));